
export enum ChatEvents {
  BLOCK_USER = 'block_user',
  UNBLOCK_USER = 'unblock_user',
  BLOCK_LIST = 'block_list',
  DELIVERED = 'delivered',
  SEEN = 'seen',
  TYPING = 'typing',
  ARCHIVE_ROOM = 'archive_room',
  GET_ROOMS = 'get_rooms',
  GET_MESSAGES = 'get_messages',
  CHECK_ONLINE_STATUS = 'check_online_status',
  UPDATE_ONLINE_STATUS = 'update_online_status',
  DELETE_MESSAGE = 'delete_message',
  SEND_MESSAGE = 'send_message',
  SELECT_ROOM = 'select_room',
  UPDATE_MESSAGES = 'message',
  SEEN_ALL = 'seen_all',
  get_system_messages_rooms = 'get_system_messages_rooms',
  rooms_unread_count = 'rooms_unread_count',
  post_unread_rooms = 'post_unread_rooms',
  get_rooms_with_options = 'get_rooms_with_options',
  user_info = 'user_info',

}

export enum SocketEvents {
  CONNECT = 'connect',
  DISCONNECT = 'disconnect',
  CONNECT_ERROR = 'connect_error',
}

export enum EventData {
  PAYLOAD = 'payload',
  RESPONSE = 'response',
}
export enum SocketActionTypes {
  RESET_SESSION = 'RESET_SESSION',
  REMOVE_QUEUED_MESSAGE = 'REMOVE_QUEUED_MESSAGE',
  SET_SOCKET = 'SET_SOCKET',
  CONNECT = 'CONNECT',
  DISCONNECT = 'DISCONNECT',
  CONNECT_ERROR = 'CONNECT_ERROR',
  BLOCK_USER = 'BLOCK_USER',
  UNBLOCK_USER = 'UNBLOCK_USER',
  GET_BLOCK_LIST = 'GET_BLOCK_LIST',
  EMIT_DELIVERED = 'EMIT_DELIVERED',
  EMIT_SEEN = 'EMIT_SEEN',
  EMIT_TYPING = 'EMIT_TYPING',
  EMIT_ARCHIVE_ROOM = 'EMIT_ARCHIVE_ROOM',
  GET_ROOMS = 'GET_ROOMS',
  GET_MESSAGES = 'GET_MESSAGES',
  ADD_EVENT_LOG = 'ADD_EVENT_LOG',
  UPDATE_TYPING_STATUS = 'UPDATE_TYPING_STATUS',
  UPDATE_BLOCK_LIST = 'UPDATE_BLOCK_LIST',
  SET_CURRENT_MESSAGES = 'SET_CURRENT_MESSAGES',
  SET_TIMESTAMP = 'SET_TIMESTAMP',
  SET_LISTING = 'SET_LISTING',
  SET_ROOMS = 'SET_ROOMS',
  SET_IS_TYPING = 'SET_IS_TYPING',
  SET_TYPING_STATUS = 'SET_TYPING_STATUS',
  SET_TYPING_TIMEOUT_REF = 'SET_TYPING_TIMEOUT_REF',
  HANDLE_TYPING_EVENT = 'HANDLE_TYPING_EVENT',
  CHECK_ONLINE_STATUS = 'CHECK_ONLINE_STATUS',
  UPDATE_ONLINE_STATUS = 'UPDATE_ONLINE_STATUS',
  DELETE_MESSAGE = 'DELETE_MESSAGE',
  SEND_MESSAGE = 'SEND_MESSAGE',
  SELECT_ROOM = 'SELECT_ROOM',
  UPDATE_MESSAGES = 'UPDATE_MESSAGES',
  SET_USER_IDENTITY = 'SET_USER_IDENTITY',
  SEEN_ALL = 'SEEN_ALL',
  UPDATE_RESPONSE_TIME = 'UPDATE_RESPONSE_TIME',
  HANDLE_SEEN = 'HANDLE_SEEN',
  HANDLE_DELIVERED = 'HANDLE_DELIVERED',
  HANDLE_ARCHIVE = 'HANDLE_ARCHIVE',
  HANDLE_BLOCK = 'HANDLE_BLOCK',
  GET_SYSTEM_MESSAGES_ROOMS = 'GET_SYSTEM_MESSAGES_ROOMS',
  ROOMS_UNREAD_COUNT = 'ROOMS_UNREAD_COUNT',
  POST_UNREAD_ROOMS = 'POST_UNREAD_ROOMS',
  GET_ROOMS_WITH_OPTIONS='GET_ROOMS_WITH_OPTIONS',
  USER_INFO="USER_INFO",
  UPDATE_FAILED_MESSAGES="ADD_FAILED_MESSAGES",
  ADD_FAILED_MESSAGES="UPDATE_FAILED_MESSAGES",
  SET_SELECTED_ROOM_DETAILS="SET_SELECTED_ROOM_DETAILS",
  ADD_PENDING_MESSAGES="ADD_PENDING_MESSAGES",
UPDATE_PENDING_MESSAGES="UPDATE_PENDING_MESSAGES",
HANDLE_DELETE="HANDLE_DELETE",
SET_FILTER_STATUS="SET_FILTER_STATUS",
SET_MEMBER="SET_MEMBER",
SET_VERIFICATION_LEVEL="SET_VERIFICATION_LEVEL"


}
